module.exports = __webpack_public_path__ + "static/media/Kiste.57f4f895.PNG";